import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_d69e6772-669a-4c5a-9337-e48f09c8c595/artifacts/dosqwhmo_361589719_248985681240088_4755260591056983724_n.jpg";

const navLinks = [
  { name: 'Services', path: '/services' },
  { name: 'Work', path: '/work' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 left-0 right-0 z-50 bg-cream border-b border-forest/5" data-testid="navbar">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img src={LOGO_URL} alt="Warner Digital" className="h-12 w-12 rounded-full object-cover"/>
            <div className="hidden sm:block">
              <span className="font-heading font-bold text-xl text-forest block leading-tight">Warner Digital</span>
              <span className="text-forest/50 text-xs tracking-widest uppercase">Media</span>
            </div>
          </Link>
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path}
                className={`font-medium text-sm tracking-wide uppercase transition-colors hover:text-gold ${location.pathname === link.path ? 'text-gold' : 'text-forest'}`}
                data-testid={`nav-link-${link.name.toLowerCase()}`}>
                {link.name}
              </Link>
            ))}
            <Link to="/contact" data-testid="nav-cta">
              <Button className="bg-gold text-forest-dark hover:bg-gold-light rounded-full px-6 py-5 font-semibold text-sm tracking-wide uppercase">
                Hire Us <ArrowUpRight className="ml-1" size={16} />
              </Button>
            </Link>
          </div>
          <button className="md:hidden p-2 text-forest" onClick={() => setIsOpen(!isOpen)} data-testid="mobile-menu-toggle">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-cream border-t border-forest/10" data-testid="mobile-menu">
            <div className="container-custom py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link key={link.path} to={link.path}
                  className={`font-medium py-2 text-sm tracking-wide uppercase transition-colors ${location.pathname === link.path ? 'text-gold' : 'text-forest'}`}
                  onClick={() => setIsOpen(false)} data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}>
                  {link.name}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setIsOpen(false)}>
                <Button className="bg-gold text-forest-dark hover:bg-gold-light rounded-full w-full font-semibold mt-2 tracking-wide uppercase">
                  Hire Us <ArrowUpRight className="ml-1" size={16} />
                </Button>
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
